import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, Send, CheckCircle, User, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ContactSupport() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact Support | IntelliEats';
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`IntelliEats Support: Message from ${name}`);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    window.location.href = `mailto:intellieats@gmail.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-670">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-671">
        <header className="mb-12" data-id="element-672">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-673">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-674" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-675">
            <div className="bg-blue-100 text-blue-600 p-3 rounded-2xl" data-id="element-676">
              <Mail className="w-8 h-8" data-id="element-677" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-678">
              Contact Support
            </h1>
          </div>
          <p className="text-lg text-slate-600" data-id="element-679">
            Have a question, feedback, or need help? We'd love to hear from you.
            Fill out the form below and we'll get back to you as soon as
            possible.
          </p>
        </header>

        {submitted ? <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="text-center py-16" data-id="element-680">
            <div className="bg-brand-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-681">
              <CheckCircle className="w-10 h-10 text-brand-600" data-id="element-682" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-683">
              Your email client should open shortly!
            </h2>
            <p className="text-slate-600 mb-8 max-w-md mx-auto" data-id="element-684">
              Please send the pre-filled email to complete your message. If your
              email client didn't open, you can email us directly at{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 font-medium hover:text-brand-700" data-id="element-685">
                intellieats@gmail.com
              </a>
            </p>
            <button onClick={() => {
          setSubmitted(false);
          setName('');
          setEmail('');
          setMessage('');
        }} className="px-6 py-3 bg-brand-600 text-white font-semibold rounded-xl hover:bg-brand-700 transition-colors" data-id="element-686">
              Send Another Message
            </button>
          </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-687">
            <div data-id="element-688">
              <label htmlFor="name" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-689">
                <User className="w-4 h-4 text-slate-500" data-id="element-690" />
                Your Name
              </label>
              <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} required placeholder="Enter your full name" className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all" data-id="element-691" />
            </div>

            <div data-id="element-692">
              <label htmlFor="email" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-693">
                <Mail className="w-4 h-4 text-slate-500" data-id="element-694" />
                Email Address
              </label>
              <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="your@email.com" className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all" data-id="element-695" />
            </div>

            <div data-id="element-696">
              <label htmlFor="message" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-697">
                <MessageSquare className="w-4 h-4 text-slate-500" data-id="element-698" />
                Message
              </label>
              <textarea id="message" value={message} onChange={e => setMessage(e.target.value)} required rows={6} placeholder="Tell us how we can help you..." className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all resize-none" data-id="element-699" />
            </div>

            <button type="submit" className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-brand-600 text-white font-bold rounded-xl hover:bg-brand-700 transition-all shadow-lg shadow-brand-200/50 hover:shadow-brand-300/50 hover:-translate-y-0.5 duration-200" data-id="element-700">
              <Send className="w-5 h-5" data-id="element-701" />
              Send Message
            </button>

            <p className="text-center text-sm text-slate-500" data-id="element-702">
              Your message will be sent to{' '}
              <span className="font-medium text-slate-700" data-id="element-703">
                intellieats@gmail.com
              </span>{' '}
              via your email client.
            </p>
          </form>}

        {/* Direct Contact Info */}
        <div className="mt-16 pt-12 border-t border-slate-100" data-id="element-704">
          <h3 className="text-lg font-bold text-slate-900 mb-6 text-center" data-id="element-705">
            Other Ways to Reach Us
          </h3>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-706">
            <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 text-center" data-id="element-707">
              <Mail className="w-6 h-6 text-brand-600 mx-auto mb-3" data-id="element-708" />
              <h4 className="font-bold text-slate-900 mb-1" data-id="element-709">Email</h4>
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 text-sm font-medium transition-colors" data-id="element-710">
                intellieats@gmail.com
              </a>
            </div>
            <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 text-center" data-id="element-711">
              <MessageSquare className="w-6 h-6 text-brand-600 mx-auto mb-3" data-id="element-712" />
              <h4 className="font-bold text-slate-900 mb-1" data-id="element-713">
                App Store Review
              </h4>
              <p className="text-sm text-slate-600" data-id="element-714">
                Leave feedback on the App Store or Google Play
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}